import gql from 'graphql-tag';
// import { getFYList } from '../../../util/shared/tmc-global';
import { clients } from '../../../util/clients';
import { toShortDate } from '../../../util/shared/tmc-global';
import {
  fieldsToGqlString, mergeByIdNewAtTop,
} from '../../../util/shared/vue-global';
import { taxPaymentTransactionActions } from './transaction.action';
import { privateVuex } from '../../auth/private';

const { backend } = clients.direct;

// loadUnapprovedAuditCount can overlap itself (the 5 minute poll, a reload after a save, a login),
// and answers do not always come back in the order they were asked. Only the latest call may
// write the count, so a slow older answer cannot overwrite a fresher one.
let latestAuditCountRequest = 0;

const taxFileds = {
  _id: '',
  taxYear: '',
  taxId: '',
  schoolDistrict: '',
  taxAmt: '',
  penaltyAmt: '',
  taxType: '',
  propertyTaxType: '',
  itsNewRecord: '',
  grossAssessed: '',
  fees: {
    feeDescription: '',
    feeMongoId: '',
    feeAmount: '',
    feeNumber: '',
  },
  total: '',
  statusCode: '',
  protest: '',
  posted: '',
  void: '',
  reciept: '',
  totalFees: '',
  isItFromPaymentTaxDetails: '',
  ownerName: '',
};

const paymentDetails = {
  _id: '',
  checkNumber: '',
  paymentType: '',
  eftType: '',
  creditType: '',
  amount: '',
  paidBy: '',
  isReconcilled: '',
  ccProcessed: '',
  overpaymentAmt: '',
};

const defaultMoreTaxFileds = {
  // fiscalYear: '',
  ...taxFileds,
};

const taxPaymentRecordFields = {
  _id: '',
  paymentDate: '',
  payment: '',
  reciept: '',
  taxDetailsCount: 0,
  total: '',
  taxesPaid: '',
  paymentMethod: '',
  paidBy: '',
  penaltyFees: '',
  posted: '',
  workstation: '',
  hasFiles: '',
  isFirstTimePrintReceipt: '',
  mail: '',
  totalAllPenaltyAmt: '',
  totalAllFees: '',
  username: '',
  taxDetails: {
    ...taxFileds,
    ownerName: '',
    taxTypeDesc: '',
  },
  paymentDetails: {
    ...paymentDetails,
  },
};

const defaultTransactionPaymnetListFields = {
  _id: '',
  auditRecordsForVoid: '',
  hasFiles: '',
  taxDetails: {
    ...taxFileds,
    isItNewVoidedRecord: '',
  },
  fiscalYear: '',
  payDate: '',
  paymentNumber: '',
  workstation: '',
  overUnderStatus: '',
  misMatchFlag: '',
  loadMoreTax: '',
  isFirstTimePrintReceipt: '',
  mail: '',
  createdBy: '',
  createdWhen: '',
  paymentDetails: {
    ...paymentDetails,
  },
};

const postedErrDetails = {
  no: '',
  wkstno: '',
  payNo: '',
  reciept: '',
  taxIdWithYear: '',
  overPaidTaxYear: '',
  overPaidTaxId: '',
};

// Warning-only rows from the Pre-Post Error Check; must be requested or they never reach the client
const ccUnprocessedDetails = {
  paymentNumber: '',
  fiscalYear: '',
  workstation: '',
  payDate: '',
  paidBy: '',
  amount: '',
  creditType: '',
};

const defaultPostedPaymentListFields = {
  statusCode: '',
  postedCounts: '',
  errorMsg: { ...postedErrDetails },
  ccUnprocessedItems: { ...ccUnprocessedDetails },
};

const defaultPaidByPaymnetListFields = {
  _id: '',
  statusCode: '',
  paymentDetails: {
    ...paymentDetails,
  },
};

const defaultReverseEntirePaymentListFields = {
  _id: '',
  workstation: '',
  payDate: '',
  feeAmount: '',
  feeNumber: '',
  feeDescription: '',
  statusCode: '',
};

const defaultTransactionPaymentAuditFields = {
  _id: '',
  workstation: '',
  paymentNumberAudit: '',
  approvalStatus: '',
  businessdate: '',
  auditSummary: '',
  reciept: '',
  user: '',
  auditReason: '',
  system: '',
  approvalTime: '',
  approvalDate: '',
  approved: '',
  approvalUser: '',
};

const largeTaxDetails = {
  ...taxFileds,
  fiscalYear: '',
  paymentNumber: '',
  initialTaxAmt: '',
  initialPenaltyAmt: '',
  initialTotalFees: '',
  initialFees: {
    feeDescription: '',
    feeMongoId: '',
    feeAmount: '',
    feeNumber: '',
  },
  initialTaxYear: '',
  initialTaxId: '',
  totalTax: '',
};
const defaultLargeayments = {
  _id: '',
  taxDetails: largeTaxDetails,
  paymentDetails,
  fiscalYear: '',
  paymentNumber: '',
  payDate: '',
  workstation: '',
  paidBy: '',
  isFirstTimePrintReceipt: '',
  // Aggregated totals from server for pagination
  totalTaxAmt: '',
  totalFees: '',
  totalRecords: '',
  totalDue: '',
  totalPenalty: '',
};

const pickListTaxDetails = {
  taxYear: '',
  taxId: '',
  schoolDistrict: '',
  taxAmt: '',
  penaltyAmt: '',
  taxType: '',
  propertyTaxType: '',
  itsNewRecord: '',
  grossAssessed: '',
  fees: {
    feeDescription: '',
    feeMongoId: '',
    feeAmount: '',
    feeNumber: '',
  },
  total: '',
  statusCode: '',
  void: '',
  protest: '',
  posted: '',
  reciept: '',
  totalFees: '',
  isItFromPaymentTaxDetails: '',
  ownerName: '',
  originalTaxId: '',
  originalTaxAmount: '',
  Half: '',
  totalTax: '',
  mtgCode: '',
  exemptAmt: '',
  isExempt: '',
};
const pickListLargeList = {
  taxDetails: { ...pickListTaxDetails, disableHalf: '' },
  paymentDetails,
  fiscalYear: '',
  paymentNumber: '',
  payDate: '',
  workstation: '',
  warningMessage: '',
};

export const taxPayment = {
  namespaced: true,
  state: () => ({
    selectedItems: [],
    selectedItemsBelowTable: [],
    selectedPamentsRecords: [],
    isDialog: false,
    transactions: undefined,
    payment: [],
    wkstNumList: [],
    paymentWkstNumList: [],
    checkReconcilation: [],
    checkReconciled: [],
    nextPaymentNumber: undefined,
    minimizeTRToggleApiCalls: null, // used in dialogTaxDetails to minimize api call
    disableOverUnderPay: false,
    misMatchItemsList: [],
    paymentDialogBusinessDate: '',
    overPayItemsList: [],
    halfOrPostmark: {
      half: false,
      postmark: false,
      dialogHalf: false,
      dialogPostmark: false,
    },
    paymentShotCutStore: {
      isItTaxRecordNCounter: 0,
      isItPayRecordNCounter: 0,
      paymentAddIconStatus: false,
    },
    isThereAnyUnpaids: false,
    skipNextApiCallForLargePayments: false,
    paymentsFilterDate: null,
    upsertItem: {},
    unapprovedAuditCount: 0,
  }),
  mutations: {
    setDialog(state, isDialog) {
      state.isDialog = isDialog;
    },
    setSelectedItems(state, items) {
      state.selectedItems = items;
    },
    setSelectedItemsBelowTable(state, items) {
      state.selectedItemsBelowTable = items;
    },
    setWkstList(state, wkstNumList) {
      state.wkstNumList = wkstNumList;
    },
    setPaymentsWkstList(state, item) {
      state.paymentWkstNumList = item;
    },
    setReconcilation(state, checkReconcilation) {
      state.checkReconcilation = checkReconcilation;
    },
    setReconciled(state, checkReconciled) {
      state.checkReconciled = checkReconciled;
    },
    setStats(state, results) {
      state.nextPaymentNumber = results.max + 1;
    },
    setHalfOrPostmark(state, { res, whichOne }) {
      state.halfOrPostmark[whichOne] = res;
    },
    setSkipNextApiCallForLargePayments(state, res) {
      state.skipNextApiCallForLargePayments = res;
    },
    setIsThereAnyUnpaids(state, val) {
      state.isThereAnyUnpaids = val;
    },
    setPaymentShotCutStore(state, { res, whichOne }) {
      if (res === 'reset') {
        state.paymentShotCutStore = {
          isItTaxRecordNCounter: 0,
          isItPayRecordNCounter: 0,
          paymentAddIconStatus: false,
        };
      } else state.paymentShotCutStore[whichOne] = res;
    },
    setMinimizeTRToggleApiCalls(state, item) {
      state.minimizeTRToggleApiCalls = item;
    },
    setDisableOverUnderPay(state, item) {
      state.disableOverUnderPay = item;
    },
    setMisMatchItemsList(state, item) {
      state.misMatchItemsList = item;
    },
    setPaymentDialogBusinessDate(state, item) {
      state.paymentDialogBusinessDate = item;
    },
    setOverPayItemsList(state, item) {
      state.overPayItemsList = item;
    },
    setTaxDetails(state, taxDetails) {
      state.taxDetails = taxDetails;
    },
    setUpsertItem(state, value) {
      state.upsertItem = value;
    },
    setPaymentsFilterDate(state, value) {
      state.paymentsFilterDate = value;
    },
    setUnapprovedAuditCount(state, count) {
      state.unapprovedAuditCount = count;
    },
    updatePaymentLocalFileStatus(state, { objectId, status }) {
      const key1 = 'paymentTransactionList';
      const result1 = this.getters['base/crud/items'](key1).find(
        (object) => (object._id || '').toString() === (objectId || '').toString(),
      );

      (result1 || {}).hasFiles = status;

      const key2 = 'paymentsRecords';
      const result2 = this.getters['base/crud/items'](key2).find(
        (object) => (object._id || '').toString() === (objectId || '').toString(),
      );
      (result2 || {}).hasFiles = status;
    },
  },
  getters: {
    getDialog(state) {
      return state.isDialog;
    },
    getPaymentDialogBusinessDate: (state) => {
      const dateStr = state.paymentDialogBusinessDate;
      if (dateStr && typeof dateStr === 'string' && dateStr.match(/^\d{2}-\d{2}-\d{4}$/)) {
        return dateStr;
      }
      return toShortDate(new Date());
    },
    // What the Payments menu item / Auditing tab badges show: only payment admins ever see a
    // number, so a count left over from an admin who just logged out never reaches anyone else.
    unapprovedAuditBadgeCount: (state, getters, rootState, rootGetters) => (
      rootGetters['auth/token/isPaymentAdmin'] ? state.unapprovedAuditCount : 0
    ),
  },
  actions: {
    async loadPayment({ commit, dispatch }, {
      baseCrudKey, criteria, fields, postProcessTrans, signal,
    }) {
      let results;
      try {
        const gqlfields = fields || defaultTransactionPaymnetListFields;
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`
            query taxPayments($criteria: taxPaymentsCriteriaType) {
              taxPayments(criteria: $criteria) {
                ${fieldsToGqlString(gqlfields)},
              }
            }
          `,
          variables: { criteria },
          fetchPolicy: 'no-cache',
          context: {
            fetchOptions: {
              signal,
            },
          },
        });
        clients.handleGQLErrors(results, commit);
        if (baseCrudKey && results.data && results.data.taxPayments) {
          const paymentsData = postProcessTrans
            ? postProcessTrans(results.data.taxPayments)
            || [] : results.data.taxPayments;
          commit('base/crud/setItems', [baseCrudKey, paymentsData], { root: true });
        }
        return results.data.taxPayments;
      } catch (e) {
        dispatch('logException', e, { root: true });
        clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem getting payment transactions list.', { root: true });
        return [];
      }
    },
    async loadLargePayments({ commit, dispatch },
      {
        baseCrudKey, criteria, fields, postProcessTrans,
      }) {
      let results;
      try {
        const gqlfields = fields || defaultLargeayments;
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`
            query largePaymentRecords($criteria: moreTaxCriteraType) {
              largePaymentRecords(criteria: $criteria) {
                ${fieldsToGqlString(gqlfields)},
              }
            }
          `,
          variables: { criteria },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        if (baseCrudKey && results.data && results.data.largePaymentRecords) {
          const { taxDetails } = results.data.largePaymentRecords;
          const paymentsData = postProcessTrans
            ? postProcessTrans(taxDetails)
            || [] : taxDetails;
          commit('base/crud/setItems', [baseCrudKey, paymentsData], { root: true });
          results = results.data.largePaymentRecords;
        }
      } catch (e) {
        dispatch('logException', e, { root: true });
        clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem getting payment transactions list.', { root: true });
        return [];
      }
      return results;
    },
    // eslint-disable-next-line consistent-return
    async pickListLargePayments({ commit, dispatch }, {
      baseCrudKey, criteria, fields, postProcessTrans,
    }) {
      let results;
      try {
        const gqlfields = fields || pickListLargeList;
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`
            query pickListLargePayments($criteria: pickListCriteriaType) {
              pickListLargePayments(criteria: $criteria) {
                ${fieldsToGqlString(gqlfields)},
              }
            }
          `,
          variables: { criteria },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        if (baseCrudKey && results.data && results.data.pickListLargePayments) {
          const { taxDetails } = results.data.pickListLargePayments;
          results = results.data.pickListLargePayments;
          const paymentsData = postProcessTrans
            ? postProcessTrans(taxDetails)
            || [] : taxDetails;

          commit('base/crud/setItems', [baseCrudKey, paymentsData], { root: true });
          if ((results.warningMessage || []).length > 0) {
            return results;
          }
        }
      } catch (e) {
        dispatch('logException', e, { root: true });
        clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem getting payment transactions list.', { root: true });
        return [];
      }
      return results;
    },
    async loadTaxPayments({ commit, dispatch }, { criteria, baseCrudKey }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`
          query taxPaymentRecord($criteria: taxPaymentrecordCriteriaType) {
            taxPaymentRecord(criteria: $criteria) {
              ${fieldsToGqlString(taxPaymentRecordFields)},
            }
          }
        `,
          variables: { criteria },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        if (results.data) {
          const { taxPaymentRecord } = results.data;
          commit('base/crud/setItems', [baseCrudKey, taxPaymentRecord], { root: true });
        }
      } catch (e) {
        dispatch('logException', e, { root: true });
        clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem getting tax payment record.', { root: true });
      }
    },
    async loadPaymentAuditRecords({ commit, dispatch }, {
      criteria, fields, baseCrudKey, postProcessTrans,
    }) {
      let results;
      try {
        const gqlfields = fields || defaultTransactionPaymentAuditFields;
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`
            query taxPaymentAudit($criteria: taxPaymentAuditCriteriaType) {
              taxPaymentAudit(criteria: $criteria) {
                ${fieldsToGqlString(gqlfields)},
              }
            }
          `,
          variables: { criteria },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        if (baseCrudKey && results.data && results.data.taxPaymentAudit) {
          const taxPaymentAuditData = postProcessTrans
            ? postProcessTrans(results.data.taxPaymentAudit)
            || [] : results.data.taxPayments;
          commit('base/crud/setItems', [baseCrudKey, taxPaymentAuditData], { root: true });
        }
        return results.data.taxPaymentAudit;
      } catch (e) {
        dispatch('logException', e, { root: true });
        clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem getting audit transactions.', { root: true });
        return [];
      }
    },
    // Number of audit records still awaiting approval - the badge on the Payments menu item and
    // the Auditing tab. Quiet on purpose, it also runs from a timer: no toast on failure (the
    // last count stays) and no reAuth, which would put the login dialog up from a background poll.
    async loadUnapprovedAuditCount({ commit, rootGetters }) {
      latestAuditCountRequest += 1;
      const request = latestAuditCountRequest;
      if (!rootGetters['auth/token/isPaymentAdmin']) {
        commit('setUnapprovedAuditCount', 0);
        return;
      }
      if (!privateVuex.getAuthIfValid().jwt) return;
      try {
        const results = await backend.query({
          query: gql`
            query taxPaymentAuditCount($criteria: taxPaymentAuditCriteriaType) {
              taxPaymentAuditCount(criteria: $criteria)
            }
          `,
          variables: { criteria: { approvalStatus: false } },
          fetchPolicy: 'no-cache',
        });
        // A newer call (a save, or the user changing) has taken over - this answer is stale.
        if (request !== latestAuditCountRequest) return;
        commit('setUnapprovedAuditCount', (results.data && results.data.taxPaymentAuditCount) || 0);
      } catch (e) {
        console.warn('[taxPayment] loadUnapprovedAuditCount failed:', e.message);
      }
    },
    // async loadCheckReconcilation({ commit, dispatch },
    //   { baseCrudKey, criteria, reconcilationedBaseCrudKey }) {
    //   let results;
    //   try {
    //     await dispatch('reAuth', null, { root: true });
    //     results = await backend.query({
    //       query: gql`
    //         query taxPayments($criteria: taxPaymentsCriteriaType) {
    //           taxPayments(criteria: $criteria) {
    //             _id
    //             workstation
    //             cashTotal
    //             paymentNumber,
    //             payDate,
    //             paymentDetails {
    //               checkNumber
    //               amount
    //               paidBy
    //               isReconcilationed
    //               paymentType,
    //               eftType,
    //               creditType,
    //             }
    //           }
    //         }
    //       `,
    //       variables: { criteria },
    //       fetchPolicy: 'no-cache',
    //     });
    //     clients.handleGQLErrors(results, commit);
    //     if (baseCrudKey && results.data && results.data.taxPayments) {
    //       const processedData = results.data.taxPayments.map((payment) => ({
    //         _id: payment._id || null,
    //         isReconcilationed: (payment.paymentDetails[0] || {}).isReconcilationed || null,
    //         workstation: payment.workstation || null,
    //         cashTotal: payment.cashTotal || null,
    //         paymentNumber: payment.paymentNumber,
    //         paymentType: (payment.paymentDetails[0] || {}).paymentType || null,
    //         eftType: (payment.paymentDetails[0] || {}).eftType || null,
    //         creditType: (payment.paymentDetails[0] || {}).creditType || null,
    //         checkNumber: (payment.paymentDetails[0] || {}).checkNumber || null,
    //         amount: (payment.paymentDetails[0] || {}).amount || null,
    //         paidBy: (payment.paymentDetails[0] || {}).paidBy || null,
    //       }));
    //       const unReconsiledData = processedData.filter((el) => !el.isReconcilationed);
    //       const reconsiledData = processedData.filter((el) => el.isReconcilationed);
    //       commit('base/crud/setItems', [baseCrudKey, unReconsiledData], { root: true });
    //       commit('base/crud/setItems', [
    // reconcilationedBaseCrudKey, reconsiledData], { root: true });
    //       return processedData;
    //     }
    //     return results.data.taxPayments;
    //   } catch (e) {
    //     dispatch('logException', e, { root: true });
    //     clients.handleGQLErrors(results, commit);
    //     dispatch('flashError',
    // 'There was a problem getting check reconcilation records.', { root: true });
    //     return [];
    //   }
    // },
    async loadPaymentsWkstList({ commit, dispatch }) {
      try {
        const query = gql`query paymentsWkstList { paymentsWkstList }`;
        const { data } = await backend.query({
          query,
          fetchPolicy: 'no-cache',
        });

        if (data && data.paymentsWkstList) {
          commit('setPaymentsWkstList', data.paymentsWkstList);
          return data.paymentsWkstList;
        }
        throw new Error('No workstation numbers were returned.');
      } catch (error) {
        dispatch('logException', error, { root: true });
        dispatch('flashError', 'There was a problem getting workstation numbers.', { root: true });
        return [];
      }
    },
    async upsertTaxPayment({ dispatch, rootGetters, commit }, {
      item, fields, baseCrudKey, postProcessTransaction, avoidUpdatingCrudList,
    }) {
      let results;
      try {
        const gqlfields = fields || defaultTransactionPaymnetListFields;
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation upsertTaxPayment ($item: taxPaymentMutationFields!)  {
            upsertTaxPayment(upsert: $item) {
                    ${fieldsToGqlString(gqlfields)},
                  }
                }`,
          variables: {
            item,
          },
        });
        clients.handleGQLErrors(results, commit);
        const newTransaction = results.data ? results.data.upsertTaxPayment : {};
        // this code is not using anymore, will remove during refactor
        // if (newTransaction.paymentAuditRecord) {
        //   const auditRecord = newTransaction.paymentAuditRecord;
        //   const allNull = Object.values(auditRecord).every((value) => value === null);

        //   if (allNull) {
        //     newTransaction.paymentAuditRecord = {};
        //   }
        // }
        if (baseCrudKey) {
          const paymentTransStateData = rootGetters['base/crud/items'](baseCrudKey);
          const [processedTrans] = postProcessTransaction
            ? postProcessTransaction([newTransaction]) : [newTransaction];
          // const newList = mergeByIdNewAtTop(paymentTransStateData || [], processedTrans);
          // console.info('newList', processedTrans);
          // commit('base/crud/setItems', [baseCrudKey, newList], { root: true });
          if (avoidUpdatingCrudList) {
            const newList = mergeByIdNewAtTop(paymentTransStateData || [], processedTrans);
            commit('base/crud/setItems', [baseCrudKey, newList], { root: true });
            commit('setUpsertItem', newTransaction);
            return newTransaction;
          }
        }

        return newTransaction;
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        // Show the reason the SERVER refused the save with (e.g. a Business Date before the open
        // posting period). A failure with no server message, like a dropped connection, keeps the
        // generic sentence rather than showing raw network text.
        const serverMessage = e && e.graphQLErrors && e.graphQLErrors[0] && e.graphQLErrors[0].message;
        dispatch('flashError', serverMessage || 'There was a problem in upserting the transaction!', { root: true });
      }
      return {};
    },
    async upsertOnlyPaidByPayment({ dispatch, commit }, {
      item, fields,
    }) {
      let results;
      try {
        const gqlfields = fields || defaultPaidByPaymnetListFields;
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation upsertOnlyPaidByPayment ($item: taxPaymentPaidByMutationFields!)  {
            upsertOnlyPaidByPayment(upsert: $item) {
                    ${fieldsToGqlString(gqlfields)},
                  }
                }`,
          variables: {
            item,
          },
        });
        clients.handleGQLErrors(results, commit);
        const res = results.data ? results.data.upsertOnlyPaidByPayment : {};
        if (res.statusCode === 200) dispatch('flashSuccess', 'Paid By has been updated', { root: true });
        else dispatch('flashError', 'There was a problem in upserting the paid by!', { root: true });
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem in upserting the paid by!', { root: true });
      }
    },
    async upsertReverseEntirePayment({ dispatch, commit }, {
      item, fields,
    }) {
      let results;
      try {
        const gqlfields = fields || defaultReverseEntirePaymentListFields;
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation upsertReverseEntirePayment ($item: taxReverseEntirePaymentMutationFields!)  {
            upsertReverseEntirePayment(upsert: $item) {
                    ${fieldsToGqlString(gqlfields)},
                  }
                }`,
          variables: {
            item,
          },
        });
        clients.handleGQLErrors(results, commit);
        const newTransaction = results.data ? results.data.upsertReverseEntirePayment : {};
        if (newTransaction.statusCode === 200) dispatch('flashSuccess', 'Reverse entries has been created', { root: true });
        else dispatch('flashInfo', 'The selected transaction may contain Unposted-payment/Protest records', { root: true });
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem in upserting the reverse entries!', { root: true });
      }
    },
    async upsertTaxPaymentAudit({ dispatch, rootGetters, commit }, {
      item, fields, baseCrudKey, postProcessTransaction,
    }) {
      let results;
      try {
        const gqlfields = fields || defaultTransactionPaymentAuditFields;
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation upsertTaxPaymentAudit ($item: taxPaymentAuditMutationFields!)  {
            upsertTaxPaymentAudit(upsert: $item) {
                    ${fieldsToGqlString(gqlfields)},
                  }
                }`,
          variables: {
            item,
          },
        });
        clients.handleGQLErrors(results, commit);
        const newTransaction = results.data ? results.data.upsertTaxPaymentAudit : {};

        if (baseCrudKey) {
          dispatch('flashSuccess', 'Tax Payment Audit approved', { root: true });
          const paymentTransStateData = rootGetters['base/crud/items'](baseCrudKey);
          const [processedTrans] = postProcessTransaction
            ? postProcessTransaction([newTransaction]) : [newTransaction];
          const newList = mergeByIdNewAtTop(paymentTransStateData || [], processedTrans);
          commit('base/crud/setItems', [baseCrudKey, newList], { root: true });
        }

        dispatch('loadUnapprovedAuditCount');
        return newTransaction;
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem in upserting the transaction!', { root: true });
      }
      return {};
    },
    async upsertTaxPaymentAudits({ dispatch, commit }, { item }) {
      const gqlfields = defaultTransactionPaymentAuditFields;
      try {
        await dispatch('reAuth', null, { root: true });
        const results = await backend.mutate({
          mutation: gql`mutation upsertTaxPaymentAudits($item:[taxPaymentAuditMutationFields]) {
            upsertTaxPaymentAudits(upserts:$item) {
              ${(fieldsToGqlString(gqlfields))}
            }
          }`,
          variables: {
            item,
          },
        });
        clients.handleGQLErrors(results, commit);
        const { upsertTaxPaymentAudits } = results.data;

        dispatch('loadUnapprovedAuditCount');
        return upsertTaxPaymentAudits.length ? upsertTaxPaymentAudits : [];
        // dispatch('flashSuccess', 'Tax payments audit approved!', { root: true });
      } catch (error) {
        dispatch('flashError', 'There was a problem while approving payments audit!', { root: true });
      }
      return [];
    },
    async prePostErrorCheckPayments({ dispatch, commit }, {
      item, fields,
    }) {
      let results;
      try {
        const gqlfields = fields || defaultPostedPaymentListFields;
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation prePostErrorCheckPayments ($item: taxRecordsPostedInputType!)  {
            prePostErrorCheckPayments(upsert: $item) {
                    ${fieldsToGqlString(gqlfields)},
                  }
                }`,
          variables: {
            item,
          },
        });
        clients.handleGQLErrors(results, commit);
        const { prePostErrorCheckPayments } = results.data;
        return prePostErrorCheckPayments;
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem in while error checking!', { root: true });
      }
      return {};
    },
    async postPayments({ dispatch, commit }, {
      item, fields,
    }) {
      let results;
      try {
        const gqlfields = fields || defaultPostedPaymentListFields;
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation postPayments ($item: taxRecordsPostedInputType!)  {
            postPayments(upsert: $item) {
                    ${fieldsToGqlString(gqlfields)},
                  }
                }`,
          variables: {
            item,
          },
        });
        clients.handleGQLErrors(results, commit);
        const { postPayments } = results.data;
        if (postPayments.statusCode === 200) {
          // Return message instead of flashing - popup will be shown in UI
          postPayments.message = `${postPayments.postedCounts || 0} Records posted to taxroll`;
          if (postPayments.postedCounts) {
            // channel for tax-inquiry reload
            const bcTaxInquiry = new BroadcastChannel('tax_inquiry_channel');
            bcTaxInquiry.postMessage('reload');
          }
        } else if (postPayments.statusCode === 404) {
          postPayments.message = 'No payments found to post';
        }
        return postPayments;
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem in upserting the transaction!', { root: true });
      }
      return {};
    },
    ...taxPaymentTransactionActions,

    // Pending (unposted, non-void) paymenttaxdetails rows for the given taxYear/taxId pairs -
    // the actual payment behind a 416/419 status-code alert. Never taxpayments/void:false,
    // which has no top-level void field and would match nothing.
    async getPendingPaymentDetails({ commit, dispatch }, { criteria }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`
            query pendingPaymentDetails($criteria: pendingPaymentDetailsCriteriaType) {
              pendingPaymentDetails(criteria: $criteria) {
                taxYear
                taxId
                paymentNumber
                payDate
              }
            }
          `,
          variables: { criteria },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        return (results.data && results.data.pendingPaymentDetails) || [];
      } catch (e) {
        dispatch('logException', e, { root: true });
        clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem checking for pending payments.', { root: true });
        return [];
      }
    },
    async loadWkstnList({ commit, dispatch }, { fiscalYear }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql` query taxCRStatsWkstList($fiscalYear: Int) {
              taxCRStatsWkstList(fiscalYear: $fiscalYear)
          }`,
          variables: { fiscalYear: fiscalYear || null },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        if (results.data && results.data.taxCRStatsWkstList) {
          commit('setWkstList', results.data.taxCRStatsWkstList);
          return results.data.taxCRStatsWkstList;
        }
        throw new Error('No workstation numbers were returned.');
      } catch (error) {
        dispatch('logException', error, { root: true });
        dispatch('flashError', 'There was a problem getting workstation numbers.', { root: true });
        return [];
      }
    },
    async loadMoreTax({ commit, dispatch }, { criteria }) {
      let results;
      try {
        const gqlfields = defaultMoreTaxFileds;
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`
            query moreTaxRecords($criteria: moreTaxCriteraType) {
              moreTaxRecords(criteria: $criteria) {
                ${fieldsToGqlString(gqlfields)},
              }
            }
          `,
          variables: { criteria },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        if (results.data && results.data.moreTaxRecords) {
          return results.data.moreTaxRecords;
        }
        return [];
      } catch (e) {
        dispatch('logException', e, { root: true });
        // clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem getting payment transactions list.', { root: true });
      }
      return [];
    },
    async upsertPaymentById({ dispatch, commit }, {
      item,
    }) {
      let results;
      try {
        const gqlfields = {
          _id: '',
        };
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation upsertById ($item: taxPaymentMutationFields!)  {
            upsertById(upsert: $item) {
                    ${fieldsToGqlString(gqlfields)},
                  }
                }`,
          variables: {
            item,
          },
        });
        clients.handleGQLErrors(results, commit);
        const newTransaction = results.data ? results.data.upsertById : {};
        return newTransaction;
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem in upserting the transaction!', { root: true });
      }
      return {};
    },
  },
};

export default taxPayment;
